export const Modules = [
  {
    selectorName: "Modal",
    selector: ".js-module-modal",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/modal/modal-module"),
  },
  {
    selectorName: "Streamer",
    selector: `.js-module-streamer`,
    importModule: () => import(/* webpackPrefetch: true */ "../shared/streamer/streamer-module"),
  },
  {
    selectorName: "CampaignBanner",
    selector: `.js-module-campaign`,
    importModule: () => import(/* webpackPrefetch: true */ "../shared/campaign-banner/campaign-banner"),
  },
  {
    selectorName: "MainNavigation",
    selector: `.js-module-main-navigation`,
    importModule: () => import(/* webpackPrefetch: true */ "../shared/main-navigation/main-navigation-module"),
  },
  {
    selectorName: "FeatureBanner",
    selector: ".js-module-feature-banner",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/feature-banner/feature-banner-module"),
  },
  {
    selectorName: "SpotButtonSlider",
    selector: ".js-module-spot-button-slider",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/spot-button-slider/spot-button-slider-module"),
  },
  {
    selectorName: "LogoSlider",
    selector: ".js-module-logo-slider",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/logo-slider/logo-slider-module"),
  },
  {
    selectorName: "ProcedureBanner",
    selector: ".js-module-procedure-banner",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/procedure-banner/procedure-banner-module"),
  },
  {
    selectorName: "SpotButtonsModule",
    selector: ".js-module-spot-buttons",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/spot-button/spot-buttons-module"),
  },
  {
    selectorName: "TagListModule",
    selector: ".js-module-category-tag-list",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/tag-list/tag-list-module"),
  },
  {
    selectorName: "SeoBlockModule",
    selector: ".js-module-seo",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/seo-block/seo-block-module"),
  },
  {
    selectorName: "MessageTileModule",
    selector: ".js-module-message-tile",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/message-tile/message-tile-module"),
  },
  {
    selectorName: "ShopButtonModule",
    selector: ".js-module-shop-button",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/shop-button/shop-button-module"),
  },
  {
    selectorName: "ParkingApp",
    selector: ".js-module-parking-root",
    importModule: () => import(/* webpackPrefetch: true */ "../booking/ParkingApp"),
  },
  {
    selectorName: "ParkingBookingStarterTeaser",
    selector: ".js-module-parking-bookingstarter",
    importModule: () => import(/* webpackPrefetch: true */ "../booking/ParkingBookingStarterTeaser"),
  },
  {
    selectorName: "ParkingProductBookingStarterModule",
    selector: ".js-module-parking-product-bookingstarter",
    importModule: () => import(/* webpackPrefetch: true */ "../booking/ParkingProductBookingStarter/ParkingProductBookingStarterModule.js"),
  },
  {
    selectorName: "ParkingTransportBookingHero",
    selector: ".js-module-parking-transport-booking-hero",
    importModule: () => import(/* webpackPrefetch: true */ "../booking/ParkingTransportBookingHero"),
  },
  {
    selectorName: "TypeAheadApp",
    selector: ".js-module-input-search",
    importModule: () => import(/* webpackPrefetch: true */ "../typeahead/TypeAheadApp"),
  },
  {
    selectorName: "LoginStateApplet",
    selector: ".js-module-login-state",
    importModule: () => import(/* webpackPrefetch: true */ "../booking/LoginStateApplet"),
  },
  {
    selectorName: "FlightSignup",
    selector: ".js-module-flight-signup",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/flight/flight-signup-module"),
  },
  {
    selectorName: "PageView",
    selector: ".js-module-pageview",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/pageview/pageview-module"),
  },
  {
    selectorName: "AirportList",
    selector: ".js-module-airport-list",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/destination/airport-list-module"),
  },
  {
    selectorName: "AirlineList",
    selector: ".js-module-airline-list",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/airlines/airline-list-module"),
  },
  {
    selectorName: "TravelGuideModule",
    selector: ".js-module-travel-guide",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/travel-guide/travel-guide-module"),
  },
  {
    selectorName: "ProfileTravelGuideModule",
    selector: ".js-profile-travel-guide",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/profile-travel-guide/profile-travel-guide-module"),
  },
  {
    selectorName: "CovidQAModule",
    selector: ".js-covid-qa",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/covid-qa-module/covid-qa-module"),
  },
  {
    selectorName: "AccordionModule",
    selector: ".js-module-accordion",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/accordion/accordion-module"),
  },
  {
    selectorName: "TravelInfoBlock",
    selector: ".js-travel-info-block",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/travel-info-block/travel-info-block"),
  },
  {
    selectorName: "ValidationPage",
    selector: ".js-validation-page",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/validation-page/validation-page"),
  },
  {
    selectorName: "ProfilePage",
    selector: ".js-profile-page",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/profile-page/profile-page"),
  },
  {
    selectorName: "Itinerary",
    selector: ".js-itinerary-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/itinerary/itinerary-module"),
  },
  {
    selectorName: "MerchantTypeaheadModule",
    selector: ".js--module-merchant-search",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/merchant/typeahead/merchant-typeahead-module"),
  },
  {
    selectorName: "MerchantListModule",
    selector: ".js--merchant-list-page-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/merchant/list-page/merchant-list-module"),
  },
  {
    selectorName: "MerchantCarouselModule",
    blockName: "MerchantCarouselBlock",
    selector: ".js--merchant-carousel-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/merchant/frontpage/carousel/merchant-carousel-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/merchant/frontpage/carousel/merchant-carousel"),
  },
  {
    selectorName: "MerchantFurtherInspirationModule",
    selector: ".js--merchant-further-inspiration-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/merchant/further-inspiration-links/merchant-further-inspiration-module"),
  },
  {
    selectorName: "TeaserMessageCardModule",
    selector: ".js--teaser-message-card-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/teaser-card/teaser-message-card-module"),
  },
  {
    selectorName: "MerchantQuickAccessImageLinksModule",
    blockName: "MerchantQuickAccessImageLinksContainerBlock",
    selector: ".js--merchant-quick-access-images-module",
    importModule: () =>
      import(/* webpackPrefetch: true */ "../shared/merchant/frontpage/quick-access-images/merchant-quic-access-image-links-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/merchant/frontpage/quick-access-images/merchant-quick-access-image-links"),
  },
  {
    selectorName: "ContentBannerIconModule",
    blockName: "ContentBannerIconBlock",
    selector: ".js--content-banner-icon-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/content-banner/content-banner-icon-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/content-banner/content-banner-icon"),
  },
  {
    selectorName: "MerchantPageHeroModule",
    selector: ".js--merchant-page-hero-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/merchant/merchant-page/hero/merchant-page-hero-module"),
  },
  {
    selectorName: "MerchantPageMapSectionModule",
    selector: ".js--merchant-page-map-section-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/merchant/merchant-page/map-section/merchant-page-map-section-module"),
  },
  {
    selectorName: "MerchantPageProductBannerModule",
    selector: ".js--merchant-page-products-banner-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/merchant/merchant-page/product-banner/merchant-page-product-banner-module"),
  },
  {
    selectorName: "MerchantPageSpotProductsModule",
    blockName: "MerchantSpotProductContainerBlock",
    selector: ".js--merchant-page-spot-products-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/merchant/merchant-page/spot-products/merchant-page-spot-products-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/merchant/merchant-page/spot-products/merchant-page-spot-products"),
  },
  {
    selectorName: "FactsAndFiguresGifContainerModule",
    blockName: "FactsAndFiguresGifContainerBlock",
    selector: ".js--facts-and-figures-gif-container-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/facts-and-figures/facts-and-figures-gif-container-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/facts-and-figures/facts-and-figures-gif-container-component"),
  },
  {
    selectorName: "LinkButtonsBannerModule",
    blockName: "LinkButtonsContentBannerBlock",
    selector: ".js--link-buttons-banner",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/link-buttons-banner/link-buttons-banner-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/link-buttons-banner/link-buttons-banner-component"),
  },
  {
    selectorName: "LinkListAccordionModule",
    blockName: "LinkListAccordionContainerBlock",
    selector: ".js--link-list-accordion-container",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/link-list-accordion/link-list-accordion-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/link-list-accordion/link-list-accordion-component"),
  },
  {
    selectorName: "TimaticWidgetModule",
    blockName: "TimaticWidgetBlock",
    selector: ".js--timatic-widget-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/timatic-widget/timatic-widget-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/timatic-widget/timatic-widget-component"),
  },
  {
    selectorName: "TimaticWidgetContainerModule",
    blockName: "TimaticWidgetContainerBlock",
    selector: ".js--timatic-widget-container-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/timatic-widget-container/timatic-widget-container-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/timatic-widget-container/timatic-widget-container-component"),
  },
  {
    selectorName: "FollowFlightModule",
    selector: ".js--follow-flight-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/follow-flight/follow-flight-module"),
  },
  {
    selectorName: "CovidTableContainerModule",
    blockName: "CovidTableContainerBlock",
    selector: ".js--covid-table-container-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/covid-table/covid-table-container-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/covid-table/covid-table-container-component"),
  },
  {
    selectorName: "FullWidthTypeaheadBannerModule",
    selector: ".js--full-width-typeahead-banner-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/full-width-typeahead-banner/full-width-typeahead-banner-module"),
  },
  {
    selectorName: "ArrivalDeparturePageModule",
    selector: ".js--arrivals-departures-page-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/arrival-departure-page/arrival-departure-page-module"),
  },
  {
    selectorName: "FlightInformationHeroModule",
    blockName: "FlightInfoHeroBlock",
    selector: ".js--flight-info-hero-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/flight-information-hero/flight-information-hero-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/flight-information-hero/flight-information-hero"),
  },
  {
    selectorName: "ImageHeroModule",
    blockName: "ImageHeroBlock",
    selector: ".js--image-hero-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/image-hero/image-hero-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/image-hero/image-hero"),
  },
  {
    selectorName: "PracticalCardContainerModule",
    blockName: "PracticalCardContainerBlock",
    selector: ".js--practical-card-container-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/practical-card-container/practical-card-container-module.jsx"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/practical-card-container/practical-card-container"),
  },
  {
    selectorName: "PracticalFaqContainerModule",
    blockName: "FAQContainerBlock",
    selector: ".js--faq-container-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/practical-faq-container/practical-faq-container-module.jsx"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/practical-faq-container/practical-faq-container"),
  },
  {
    selectorName: "NavigationalCardContainerModule",
    blockName: "NavigationalCardContainerBlok",
    selector: ".js--navigational-card-container-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/navigational-card-container/navigational-card-container-module.jsx"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/navigational-card-container/navigational-card-container"),
  },
  {
    selectorName: "InfoBanner",
    blockName: "InfoBannerBlock",
    selector: ".js--info-banner",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/info-banner/info-banner-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/info-banner/info-banner-component"),
  },
  {
    selectorName: "NewsContainerModule",
    blockName: "NewsContainerBlock",
    selector: ".js--news-container",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/news-container/news-container-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/news-container/news-container-component"),
  },
  {
    selectorName: "LinkTilesModule",
    blockName: "LinkTilesBlock",
    selector: ".js--link-tiles-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/link-tiles/link-tiles-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/link-tiles/link-tiles-component"),
  },
  {
    selectorName: "ParkingSearchModule",
    selector: ".js--parking-search-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/parking-search/parking-search-module"),
  },
  {
    selectorName: "FlightSearchHeroModule",
    selector: ".js--flight-search-hero-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/flight-search-hero/flight-search-hero-module"),
  },
  {
    selectorName: "FlightSearchHeroSimpleModule",
    selector: ".js--flight-search-hero-simple-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/flight-search-hero-simple/flight-search-hero-simple-module"),
  },
  {
    selectorName: "FlightSearchBarModule",
    selector: ".js--flight-search-bar-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/flight-search-bar-component/flight-search-bar-module"),
  },
  {
    selectorName: "CarouselModule",
    blockName: "CarouselBlock",
    selector: ".js--carousel-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/carousel/carousel-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/carousel/carousel-component"),
  },
  {
    selectorName: "HeaderModule",
    selector: ".js--header-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/header/header-module"),
  },
  {
    selectorName: "FooterModule",
    selector: ".js--footer-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/footer/footer-module"),
  },
  {
    selectorName: "NotificationModule",
    blockName: "AnnouncementNotificationBlock",
    selector: ".js--notification-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/notification/notificaiton-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/notification/notification"),
  },
  {
    selectorName: "ArrivalsDeparturesListSearchModule",
    blockName: "ArrivalsDeparturesListSearchBlock",
    selector: ".js--arrivals-departures-list-search-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/arrivals-departures-list-search/arrivals-departures-list-search-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/arrivals-departures-list-search/arrivals-departures-list-search"),
  },
  {
    selectorName: "LinkListModule",
    blockName: "LinkListContainerBlock",
    selector: ".js--link-list-container-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/link-list/link-list-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/link-list/link-list-component"),
  },
  {
    selectorName: "SectionPageHeaderModule",
    blockName: "SectionPageHeaderBlock",
    selector: ".js--section-page-header-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/section-page-header/section-page-header-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/section-page-header/section-page-header-component"),
  },
  {
    selectorName: "AccordionAndTextContainerModule",
    blockName: "AccordionAndTextContainerBlock",
    selector: ".js--accordion-and-text-container-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/accordion-and-text-container/accordion-and-text-container-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/accordion-and-text-container/accordion-and-text-container-component"),
  },
  {
    selectorName: "HandlingAccordionContainerModule",
    blockName: "HandlingAccordionContainerBlock",
    selector: ".js--handling-accordion-container-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/handling-accordion/handling-accordion-container-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/handling-accordion/handling-accordion-container-component"),
  },
  {
    selectorName: "ServiceContentContainerModule",
    blockName: "ServiceContentContainerBlock",
    selector: ".js--service-content-container-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/service-content/service-content-container-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/service-content/service-content-container-component"),
  },
  {
    selectorName: "AirlinePageModule",
    selector: ".js--airline-page-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/airline-page/airline-page-module"),
  },
  {
    selectorName: "ImageListGridCarouselModule",
    blockName: "ImageListGridCarouselBlock",
    selector: ".js--image-list-grid-carousel-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/image-list-grid-carousel/image-list-grid-carousel-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/image-list-grid-carousel/image-list-grid-carousel-component"),
  },
  {
    selectorName: "ArticleTextUspModule",
    blockName: "ArticleTextUspBlock",
    selector: ".js--article-text-usp-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/article-text-usp/article-text-usp-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/article-text-usp/article-text-usp-component"),
  },
  {
    selectorName: "BookingHistoryModule",
    selector: ".js--booking-history",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/account/booking-history/booking-history-module.js"),
  },
  {
    selectorName: "ArticleColorUspModule",
    blockName: "ArticleColorUspBlock",
    selector: ".js--article-color-usp-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/article-color-usp/article-color-usp-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/article-color-usp/article-color-usp-component"),
  },
  {
    selectorName: "AllowedItemsListModule",
    selector: ".js--allowed-items-list-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/allowed-items-list/allowed-items-list-module"),
  },
  {
    selectorName: "GuideAccordionModule",
    blockName: "GuideAccordionBlock",
    selector: ".js--guide-accordion-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/guide-accordion/guide-accordion-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/guide-accordion/guide-accordion-component"),
  },
  {
    selectorName: "TextAndTabsContainerModule",
    blockName: "TextAndTabsContainerBlock",
    selector: ".js--text-and-tabs-container-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/text-and-tabs/text-and-tabs-container-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/text-and-tabs/text-and-tabs-container-component"),
  },
  {
    selectorName: "ValueCardsContainerModule",
    blockName: "ValueCardsContainerBlock",
    selector: ".js--value-cards-container-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/value-cards-container/value-cards-container-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/value-cards-container/value-cards-container-component"),
  },
  {
    selectorName: "AreaCardsContainerModule",
    blockName: "AreaCardsContainerBlock",
    selector: ".js--area-cards-container-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/area-cards-container/area-cards-container-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/area-cards-container/area-cards-container-component"),
  },
  {
    selectorName: "TestimonialContainerModule",
    blockName: "TestimonialContainerBlock",
    selector: ".js--testimonial-container-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/testimonial-container/testimonial-container-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/testimonial-container/testimonial-container-component"),
  },
  {
    selectorName: "NumberCardsContainerModule",
    blockName: "NumberCardsContainerBlock",
    selector: ".js--number-cards-container-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/number-cards-container/number-cards-container-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/number-cards-container/number-cards-container-component"),
  },
  {
    selectorName: "TimelineContainerModule",
    blockName: "TimelineContainerBlock",
    selector: ".js--timeline-container-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/timeline-container/timeline-container-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/timeline-container/timeline-container-component"),
  },
  {
    selectorName: "EditProfileModule",
    selector: ".js--edit-profile",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/account/Profile/edit-profile-module"),
  },
  {
    selectorName: "FullWidthImageCarouselModule",
    blockName: "FullWidthImageCarousel",
    selector: ".js--full-width-image-carousel",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/full-width-image-carousel/full-width-image-carousel-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/full-width-image-carousel/full-width-image-carousel"),
  },
  {
    selectorName: "BusinessContactModule",
    blockName: "BusinessContactBlock",
    selector: ".js--business-contact-block",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/business-contact/business-contact-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/business-contact/business-contact-component"),
  },
  {
    selectorName: "ImpressionSliderModule",
    blockName: "ImpressionSliderBlock",
    selector: ".js--impression-slider",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/impression-slider/impression-slider-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/impression-slider/impression-slider-component"),
  },
  {
    selectorName: "PartnerShowcaseModule",
    blockName: "PartnerShowcaseBlock",
    selector: ".js--partner-showcase",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/partner-showcase/partner-showcase-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/partner-showcase/partner-showcase-component"),
  },
  {
    selectorName: "ShowcaseVideoModule",
    blockName: "ShowcaseVideoBlock",
    selector: ".js--showcase-video",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/showcase-video/showcase-video-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/showcase-video/showcase-video-component"),
  },
  {
    selectorName: "MaterialProviderModule",
    blockName: "MaterialProviderBlock",
    selector: ".js--material-provider",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/material-provider/material-provider-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/material-provider/material-provider-component"),
  },
  {
    selectorName: "QuoteStatementModule",
    blockName: "QuoteStatementBlock",
    selector: ".js--quote-statement",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/quote-statement/quote-statement-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/quote-statement/quote-statement-component"),
  },
  {
    selectorName: "HeroBannerVideoModule",
    blockName: "HeroBannerVideoBlock",
    selector: ".js--hero-banner-video-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/hero-banner-video/hero-banner-video-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/hero-banner-video/hero-banner-video-component"),
  },
  {
    selectorName: "ImpressionBlockModule",
    blockName: "ImpressionBlock",
    selector: ".js--impression-block-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/impression-block/impression-block-module.jsx"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/impression-block/impression-block-component.jsx"),
  },
  {
    selectorName: "InfoContentBlockModuel",
    blockName: "InfoContentBlock",
    selector: ".js--info-content-block-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/info-content-block/info-content-block-module.jsx"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/info-content-block/info-content-block-component.jsx"),
  },
  {
    selectorName: "ImpressionHeroBlockModule",
    blockName: "ImpressionHeroBlock",
    selector: ".js--impression-hero-block-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/impression-hero-block/impression-hero-block-module.jsx"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/impression-hero-block/impression-hero-block-component.jsx"),
  },
  {
    selectorName: "TimelineBlockModule",
    blockName: "TimelineBlock",
    selector: ".js--timeline-block",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/timeline-block/timeline-block-module.jsx"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/timeline-block/timeline-block-component.jsx"),
  },
  {
    selectorName: "HotspotImageBlockModule",
    blockName: "HotspotImageBlock",
    selector: ".js--hotspot-image-block-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/hotspot-image-block/hotspot-image-block-module.jsx"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/hotspot-image-block/hotspot-image-block-component.jsx"),
  },
  {
    selectorName: "NewsContentModule",
    blockName: "NewsContentBlock",
    selector: ".js--news-content-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/news/news-content/news-content-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/news/news-content/news-content-component"),
  },
  {
    selectorName: "EmployeeProfileModule",
    blockName: "EmployeeProfileBlock",
    selector: ".js--employee-profile-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/corporate/components/employee-profile/employee-profile-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/corporate/components/employee-profile/employee-profile-component"),
  },
  {
    selectorName: "NewsOverviewBlockModule",
    blockName: "NewsOverviewBlock",
    selector: ".js--news-overview-block-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/news/news-overview/news-overview-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/news/news-overview/news-overview-block-component"),
  },
  {
    selectorName: "NewsListPageModule",
    selector: ".js--news-list-page-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/news/news-list-page/news-list-page-module"),
  },
  {
    selectorName: "DesignElementCardContainerBlockModule",
    selector: ".js--design-element-card-container-block-module",
    importModule: () =>
      import(/* webpackPrefetch: true */ "../shared/design-element-components/design-element-cards/design-element-card-container-block-module.jsx"),
  },
  {
    selectorName: "MovingGraphicBlockModule",
    blockName: "MovingGraphicBlock",
    selector: ".js--moving-graphic-block-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/moving-graphic-block/moving-graphic-block-module.jsx"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/moving-graphic-block/moving-graphic-block-component.jsx"),
  },
  {
    selectorName: "MerchantPageOtherStoreModule",
    selector: ".js--merchant-other-stores-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/merchant/merchant-page/other-stores/merchant-page-other-stores-module"),
  },
  {
    selectorName: "MerchantPageModule",
    selector: ".js--merchant-page-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/merchant/merchant-page/merchant-page-module"),
  },
  {
    selectorName: "ServiceLinkCardContainerModule",
    blockName: "ServiceLinkCardContainerBlock",
    selector: ".js--service-link-card-container-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/service-link-card-container/service-link-card-container-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/service-link-card-container/service-link-card-container-component"),
  },
  {
    selectorName: "UniverseLandingPageHeroModule",
    selector: ".js--universe-landing-page-hero-block",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/universe-landing-page-hero/universe-landing-page-hero-module.jsx"),
  },
  {
    selectorName: "MopinionModule",
    blockName: "MopinionBlock",
    selector: ".js--mopinion-block",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/mopinion/mopinion-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/mopinion/mopinion"),
  },
  {
    selectorName: "EpiFormsModule",
    blockName: "FormContainerBlock",
    selector: ".js--react-epi-forms",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/epi-forms/epi-forms-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/epi-forms/epi-forms-component"),
  },
  {
    selectorName: "ManageBookingShortcutBlock",
    blockName: "ManageBookingShortcutBlock",
    selector: ".js--manage-booking-shortcut-block-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/manage-shortcut/manage-booking-shortcut-module.jsx"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/manage-shortcut/manage-booking-shortcut-component.jsx"),
  },
  {
    selectorName: "IconLinkCardContainerModule",
    blockName: "IconLinkCardContainer",
    selector: ".js--icon-link-card-container-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/icon-link/icon-link-container-module"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/icon-link/icon-link-container-component"),
  },
  {
    selectorName: "ParkingProductPricingTableModule",
    blockName: "ParkingProductPricingTableBlock",
    selector: ".js--parking-product-pricing-table-container-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/parking-product-pricing-table/parking-product-pricing-table-module.jsx"),
    importComponent: () =>
      import(/* webpackPrefetch: true */ "../shared/parking-product-pricing-table/parking-product-pricing-table-container-component.jsx"),
  },
  {
    selectorName: "SupportPanelModule",
    blockName: "SupportPanelBlock",
    selector: ".js--support-panel-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/support-panel/support-panel-module.jsx"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/support-panel/support-panel-component.jsx"),
  },
  {
    selectorName: "CarparkPricingSummaryModule",
    blockName: "CarparkPricingSummaryBlock",
    selector: ".js--carpark-pricing-summary-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/parking-carpark-summary/carpark-pricing-summary-module.jsx"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/parking-carpark-summary/carpark-pricing-summary-component.jsx"),
  },
  {
    selectorName: "ButtonBlockModule",
    blockName: "ButtonBlock",
    selector: ".js--button-block-module",
    importModule: () => import(/* webpackPrefetch: true */ "../shared/button-block/button-block-module.js"),
    importComponent: () => import(/* webpackPrefetch: true */ "../shared/button-block/button-block-component.jsx"),
  },
  {
    selectorName: "PanningMapBlockModule",
    selector: ".js--panning-map-block-module",
    importModule: () => import(/* webpackPrefetch: true */ "../booking/components/Map/panning-map-block-module.js"),
  },
]

export default class DomFactory {
  constructor() {
    DomFactory.createModules()
    return this
  }
  static modules = {}
  static createModules() {
    for (let i = 0; i < Modules.length; i++) {
      let nodes = []
      let tags = document.querySelectorAll(Modules[i].selector)
      for (let x = 0; x < tags.length; x++) {
        Modules[i].importModule().then((module) => {
          new module.default(tags[x])
          nodes.push(module)
        })
      }
      if (nodes.length) DomFactory.modules[Modules[i].selectorName] = nodes
    }
  }
}

window.modules = DomFactory.modules
